import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errorvuex: true,
    system_framework: ''
  },
  mutations: {
    // 连接是否断开
    savePath (state, error) {
      state.errorvuex = error
    },
    framework (state, error) {
      state.system_framework = error
    },
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js